import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-saving-loader-modal',
    templateUrl: './saving-loader-modal.component.html',
    styleUrls: ['./saving-loader-modal.component.scss'],
    standalone: false
})
export class SavingLoaderModalComponent implements OnInit {

    constructor(public activeModal: NgbActiveModal) { }

    ngOnInit(): void {
    }

}
